import { create } from 'zustand';
// TODO: 주석 필요
var lastBandIndex = create(function (set) { return ({
    lastBandIndexMap: new Map(),
    setLastBandIndexMap: function (bandId, index) {
        set(function (state) {
            state.lastBandIndexMap.set(bandId, index);
            return state;
        });
    },
    clearLastBandIndexMap: function () {
        set(function (state) {
            state.lastBandIndexMap.clear();
            return {
                lastBandIndexMap: state.lastBandIndexMap,
            };
        });
    },
    lastSubBoardBandIndexMap: new Map(),
    setLastSubBoardBandIndexMap: function (bandId, index) {
        set(function (state) {
            state.lastSubBoardBandIndexMap.set(bandId, index);
            return state;
        });
    },
    clearLastSubBoardBandIndexMap: function () {
        set(function (state) {
            state.lastSubBoardBandIndexMap.clear();
            return {
                lastSubBoardBandIndexMap: state.lastSubBoardBandIndexMap,
            };
        });
    },
}); });
export var useLastBandIndexStore = lastBandIndex;
